import styled from 'styled-components/macro';

import { ColorType } from 'common/types/theme';

function generateColor(color: string, bgColor: string) {
  return `
    background-color: ${bgColor};
    color:${color};
`;
}

function pickColor(color: string, themeColor: Record<ColorType, string>) {
  switch (color) {
    case 'red':
      return generateColor(themeColor['negative_dark'], themeColor['negative_20']);
    case 'green':
      return generateColor(themeColor['positive_default'], themeColor['positive_light_0']);
    case 'grey':
      return generateColor(themeColor['black_80'], themeColor['black_10']);
    default:
      return null;
  }
}

export const Label = styled.span<{ color?: string }>`
  display: inline-block;
  padding: ${({ theme }) => `${theme.spacing.zero_1} ${theme.spacing.zero_2}`};
  border-radius: 4px;

  ${({ theme, color }) => color && pickColor(color, theme.colors)};

  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};

  text-transform: capitalize;
`;
